export default {
  id: "salesRanking",
  name: "Product Comparison",
  description: "",
  report: {
    name: "Sales Ranking",
    chartType: "",
    template: "sales-ranking",
    config: {
      dataType: "single",
      dataSet: "Product",
    },
  },
};
